import { GeoserverWMSProvider } from '../GeoserverWMSProvider'
import { WmsBaseLayer } from './WmsBaseLayer'

export class WmsDepthAreaLayer extends WmsBaseLayer {
  layername: string = '水深'
  key: string = 'depthArea'
  provider = new GeoserverWMSProvider({
    url: 'geoserver/wms',
    layers: 'cite:dep_are',
  })
}
